const cards: NodeList | null = document.querySelectorAll(".js-tag-hover");

cards.forEach((card) => {
  const tags: NodeList | null = (<Element>card).querySelectorAll(".js-tag");
  card.addEventListener("mouseenter", () => {
    tags.forEach((tag) => {
      const classes = (<Element>tag)?.className!.split(" ");
      (<Element>tag)?.classList.remove(classes![1]);
      (<Element>tag)?.classList.add("tags__tag--hover");

      card.addEventListener("mouseleave", () => {
        (<Element>tag)?.classList.remove("tags__tag--hover");
        (<Element>tag)?.classList.add(classes![1]);
      });
    });
  });
});
